import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-change-mgmt',
    templateUrl: './change-mgmt.component.html',
    styleUrls: ['./change-mgmt.component.scss'],
    standalone: false
})
export class ChangeMgmtComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
